import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { MdClose } from 'react-icons/md'

export default function DrawerRight({open, onClose, title, children, maxWidth, zIndex = 9998, disableOutsideClick = false}) {
  // Función de cierre condicional
  const handleClose = () => {
    if (!disableOutsideClick) {
      onClose();
    }
  };

  return (
    <Transition.Root 
      show={open} 
      as={Fragment}
    >
      <Dialog 
        as="div" 
        className="relative"           
        style={{ zIndex: zIndex }}
        onClose={handleClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel style={{maxWidth:maxWidth}} className="pointer-events-auto relative w-screen">
                
                  <div className="flex h-full flex-col overflow-y-scroll bg-white pb-6 shadow-xl">
                    <div className='flex flex-row justify-between items-center justify-center mb-1 px-4 sticky top-0 z-30 bg-white py-4 shadow-md'>

                      <div className="px-4 sm:px-6">
                        <Dialog.Title className="text-base font-bold leading-6 text-gray-700">
                          {title}
                        </Dialog.Title>
                      </div>

                      <div onClick={onClose} className='cursor-pointer rounded-lg hover:bg-gray-50 border border-gray-300 bg-gray-100 transition-all duration-100 text-gray-700 p-1.5'>
                        <MdClose/>
                      </div>

                    </div>
                    <div className="relative flex-1 px-4 sm:px-6">{children}</div>
                  </div>
                  
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}